
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Card,

  CircularProgress,
  Box,
  Tooltip,
} from "@mui/material";

import { useNavigate } from "react-router-dom";


const OfferIndividualTableList = ({ id, data, setData, totalPages, setTotalPages, currentPage, setCurrentPage, newloading, setnewLoading }) => {
  const navigate = useNavigate();

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };



  return (
    <>
      <Card sx={{ marginTop: 4, py: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Order Id
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  User Name
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Order Type
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Order Amount
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Payment Type
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  {" "}
                  Coupon Amount
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Delivery Charges
                </TableCell>
                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Booking Status
                </TableCell>
                {/* <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Show On App
                </TableCell>

                <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
                  Action
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {newloading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Box display="flex" justifyContent="center" py={2}>
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : data?.list?.length > 0 ? (
                data.list.map((item) => (
                  <TableRow key={item._id}>
                    <TableCell>{item?.booking_id?.orderId || 'NA'}</TableCell>

                    <Tooltip sx={{ cursor: 'pointer' }} title={item?.user_id?.phone || "NA"} placement="top">
                      <TableCell>{item?.user_id?.fullName || 'NA'}</TableCell>
                    </Tooltip>

                    <TableCell
                      sx={{
                        maxWidth: 200,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item?.booking_id?.orderType?.split(" ").length > 1
                        ? item.booking_id.orderType.split(" ")[0]
                        : item?.booking_id?.orderType}
                    </TableCell>

                    <TableCell>
                      ₹ {item.booking_id?.payment?.final_amount || '0'}
                    </TableCell>

                    <TableCell>{item?.booking_id?.paymentType || "NA"}</TableCell>
                    <TableCell>{item?.coupon_amount || 'NA'}</TableCell>
                    <TableCell>{item?.booking_id?.payment?.delivery_charges || '0'}</TableCell>
                    <TableCell>{item?.booking_id?.status || "NA"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No coupon applied users 
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </TableContainer>

        {/* Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
        />

      </Card>
    </>
  );
};

export default OfferIndividualTableList;
